import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../globalServices/permission.service';

export const offerDetailsGuard: CanActivateFn = () => {
  const permissionService = inject(PermissionService);
  const router = inject(Router);

  const isFreshDeepLink = router.getCurrentNavigation()?.previousNavigation == null;
  if (isFreshDeepLink && permissionService.isAuthenticated()) {
    // Return 403 for admins accessing a student invitation link
    if (!permissionService.hasRole('Applicant')) {
      return router.parseUrl('/error?status=403');
    }
    // Return 403 for a co-borrower accessing a student invitation link.
    const applicationRoles = permissionService.getBorrowerApplicationRoles();
    if (applicationRoles && applicationRoles.hasCoBorrower && !applicationRoles.hasApplicant) {
      return router.parseUrl('/error?status=403');
    }
    return router.parseUrl(permissionService.getApplicantRedirectUrl());
  }

  return true;
};
